import { render, staticRenderFns } from "./product-quick-win.vue?vue&type=template&id=29ac5e9f&scoped=true"
import script from "./product-quick-win.vue?vue&type=script&lang=js"
export * from "./product-quick-win.vue?vue&type=script&lang=js"
import style0 from "./product-quick-win.vue?vue&type=style&index=0&id=29ac5e9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ac5e9f",
  null
  
)

export default component.exports